import React, { useCallback, useState, useEffect } from 'react';
import { useDropzone } from 'react-dropzone';
import axios from 'axios';

const UserProfileUpload = ({ currentImage, onImageUpload, userId }) => {
  const [localImage, setLocalImage] = useState(currentImage);

  const onDrop = useCallback(async (acceptedFiles) => {
    const file = acceptedFiles[0];
    if (!file) return;

    // Modify the file name to match our business pattern
    const modifiedFile = new File(
      [file],
      `${userId}_${file.name}`,
      { type: file.type }
    );
    
    const formData = new FormData();
    formData.append('image', modifiedFile);
    formData.append('userId', userId);

    try {
      const response = await fetch('/api/user/user-profile', {
        method: 'POST',
        credentials: 'include',
        body: formData
      });
      
      const data = await response.json();
      if (response.ok) {
        setLocalImage(data.url);
        onImageUpload(data.url);
      } else {
        console.error('Upload failed:', data.error);
      }
    } catch (error) {
      console.error('Profile picture upload failed:', error);
    }
  }, [onImageUpload, userId]);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      'image/*': ['.jpeg', '.jpg', '.png', '.gif']
    },
    multiple: false
  });

  // Update local image when currentImage prop changes
  useEffect(() => {
    setLocalImage(currentImage);
  }, [currentImage]);

  // Use localImage instead of currentImage in the render
  return (
    <div className="relative w-32 h-32">
      {localImage ? (
        <div className="relative group">
          <img 
            src={localImage}
            alt="Profile"
            className="w-32 h-32 rounded-full object-cover"
          />
          <div 
            {...getRootProps()}
            className="absolute inset-0 bg-black bg-opacity-50 rounded-full hidden group-hover:flex items-center justify-center cursor-pointer"
          >
            <input {...getInputProps()} />
            <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12" />
            </svg>
          </div>
        </div>
      ) : (
        <div 
          {...getRootProps()} 
          className="w-32 h-32 rounded-full border-2 border-dashed border-gray-300 flex items-center justify-center cursor-pointer hover:border-[#00aef7]"
        >
          <input {...getInputProps()} />
          <div className="text-center">
            <svg className="w-8 h-8 mx-auto text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
            </svg>
            <p className="text-xs text-gray-500 mt-2">Add Profile Photo</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserProfileUpload;